import { jsx as i, jsxs as k, Fragment as Ae } from "react/jsx-runtime";
import { af as Je, by as Ze, aM as et, ao as Se, bh as tt, aQ as nt, C as M, G as H, a0 as _, p as fe, aE as Me, S as oe, a1 as ee, bz as te, bA as Le, am as pe, an as Fe, aD as ot, aV as at, F as st, aW as rt, bB as it, T as ct, a3 as we, bC as lt, q as mt, N as dt, aa as ut, aF as pt, aX as gt, t as St, aG as ft, Q as ht } from "./helpers-458d7e27.js";
import { createContext as Ct, useMemo as X, useContext as he, useState as F, useEffect as z, useRef as q, useCallback as De, forwardRef as Re, Fragment as He } from "react";
import { u as Oe } from "./useSubNavHeight-9afc367c.js";
import { i as wt, T as Nt } from "./TextHeaderInner-7887aa3a.js";
import { css as K, jsx as A } from "@emotion/react";
import E from "clsx";
import { a as ke } from "./index-39c86506.js";
import { a as O } from "./TextGroup-dd19925e.js";
import { createPortal as _e } from "react-dom";
const Be = Ct({
  isHandledByPageSegmentControl: !1
}), Mn = ({
  children: e
}) => {
  const t = X(() => ({ isHandledByPageSegmentControl: !0 }), []);
  return /* @__PURE__ */ i(Be.Provider, { value: t, children: e });
}, vt = () => he(Be), bt = ".page-segment-control-nav.section-wrapper", yt = ({ offsetHeight: e = 0 }) => {
  const [t, n] = F("skip-check"), { height: o } = Je(0);
  return z(() => {
    const a = document.querySelector(bt);
    if (!a)
      return n("skip-check");
    const r = ([l]) => {
      const { isIntersecting: d, intersectionRatio: u } = l;
      n((() => u === 1 ? "pinned-above-viewport" : d ? "pinned" : "unpinned")());
    }, s = -1 * (o - e - 1), c = new IntersectionObserver(r, {
      rootMargin: `10000px 0px ${s}px 0px`,
      threshold: [0, 1]
    });
    return c.observe(a), () => {
      c == null || c.unobserve(a);
    };
  }, [o, e]), t;
}, Ne = "div.page-segment-control-nav-griditem", Tt = 2, Et = Ze(
  Tt
), xt = () => {
  const e = q(null), t = q({ pinned: 0 }), { pinned: n } = Oe(), o = yt({
    offsetHeight: n
  }), { registerStickyEl: a, updateStickyElHeight: r, updateStickyElStatus: s } = he(et);
  z(() => {
    e.current = typeof document < "u" ? document.querySelector(Ne) : null, e.current && a({
      // eslint-disable-next-line sonarjs/no-duplicate-string
      type: "page-seg-ctrl",
      cssSelector: Ne,
      height: 0,
      isSticky: !1
    });
  }, [a]), z(() => {
    s({
      type: "page-seg-ctrl",
      isSticky: o === "pinned"
    });
  }, [o, s]);
  const c = De(() => {
    var d;
    const l = (((d = e.current) == null ? void 0 : d.clientHeight) || 0) + Et;
    r({ type: "page-seg-ctrl", height: l }), t.current.pinned = l;
  }, [r]);
  return Se(e.current, c), {
    pageSegCtrlEl: e,
    pageSegCtrlHeightRef: t,
    componentPinnedStatus: o
  };
}, Gt = () => {
  const { pinned: e } = Oe(), { isHandledByPageSegmentControl: t } = vt(), {
    pageSegCtrlHeightRef: {
      current: { pinned: n }
    }
  } = xt();
  return e + (t ? n : 0);
}, Ve = (e) => {
  const t = Array(e).fill(null), o = 1 / (e === 0 ? 1 : e);
  return { segmentDefsInit: t.map((r, s) => {
    const c = o * (s + 1);
    return {
      min: c - o,
      max: c,
      target: 0
    };
  }), split: o };
}, Pt = (e, t) => {
  var u, p;
  const { top: n } = ((u = e.current) == null ? void 0 : u.getBoundingClientRect()) || { top: 0 }, o = n + window.scrollY, r = (((p = e.current) == null ? void 0 : p.offsetHeight) || 0) - window.innerHeight, { segmentDefsInit: s, split: c } = Ve(t), l = r * c;
  return s.map((g, f) => (g.target = o + l * (f + 0.01), g));
}, It = (e, t, n = !1) => {
  const [o, a] = t;
  return e >= o && (n ? e <= a : e < a);
}, We = ({
  sectionRef: e,
  numSegments: t,
  scrollProgress: n,
  recalculateSegmentDefs: o
}) => {
  const { segmentDefsInit: a } = X(
    () => Ve(t),
    [t]
  ), [r, s] = F(0), [c, l] = F(a), [d, u] = F(0), p = q(-1), g = (m) => {
    m !== d && (p.current = m);
  }, f = () => {
    p.current = -1;
  }, h = X(
    () => tt((m) => {
      s(
        m[0].contentRect.height * m[0].contentRect.width
      );
    }, 300),
    []
  );
  return Se(e, h), z(() => {
    if (!o)
      return;
    const m = Pt(e, t);
    l(m);
  }, [e, t, r, o]), nt(n, "change", (m) => {
    p.current > -1 ? u(p.current) : o && c.forEach((w, N) => {
      const { min: I, max: x } = w, y = N === t - 1;
      It(m, [I, x], y) && u(N);
    });
  }), {
    segmentDefs: c,
    activeSegmentIdx: d,
    setTargetIndex: g,
    resetTargetIndex: f
  };
}, $t = (e) => {
  const t = X(() => {
    let s = "div.text-group-container";
    return e && (s = `#${e} ${s}`), s;
  }, [e]), [n, o] = F(null), a = q(0);
  z(() => {
    const s = typeof document < "u" ? document.querySelector(t) : null;
    o(s);
  }, [t]);
  const r = De(() => {
    a.current = (n == null ? void 0 : n.clientHeight) || 0;
  }, [n]);
  return Se(n, r), { textSectionElHeight: a, textSectionEl: n };
}, ze = {
  initial: {
    opacity: 0.2
  },
  animate: {
    opacity: 1
  }
}, At = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  }
}, Mt = {
  initial: {
    height: 0
  },
  animate: {
    height: "auto"
  }
}, Lt = {
  initial: {
    opacity: 0,
    zIndex: 0
  },
  animate: {
    opacity: 1,
    zIndex: 1
  }
}, Ft = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 1
  }
}, ve = (e) => {
  const {
    headline: t,
    headlineSize: n,
    headlineTag: o,
    subheading: a,
    subheadingTag: r,
    removeOrphanFromHeadline: s,
    type: c,
    byline: l,
    alignment: d
  } = e;
  return {
    headline: t,
    headlineSize: n,
    headlineTag: o,
    subheading: a,
    subheadingTag: r,
    removeOrphanFromHeadline: s,
    type: c,
    byline: l,
    alignment: d
  };
}, qe = (e) => {
  if (!wt(e))
    e = {
      textGroup: ve(e)
    };
  else {
    const { textGroup: t } = e, n = ve(
      t
    );
    e = {
      ...e,
      textGroup: n
    };
  }
  return /* @__PURE__ */ i(Nt, { ...e });
}, Ue = (e) => e.reduce(
  (t, n) => {
    var c;
    const { mediaFrame: o, textGroup: a, foregroundImages: r } = n, s = o.type === "Image" ? (c = o == null ? void 0 : o.image) == null ? void 0 : c.imageAltText : "";
    return {
      ...t,
      mediaCollection: [...t.mediaCollection, o],
      textGroupCollection: [
        ...t.textGroupCollection,
        { ...a, mediaDescription: s }
      ],
      foreGroundMediaCollection: [
        ...t.foreGroundMediaCollection,
        r
      ]
    };
  },
  {
    mediaCollection: [],
    textGroupCollection: [],
    foreGroundMediaCollection: []
  }
), Dt = (e) => e ? "60vmin" : "88vmin", Ce = (e, t, n = !1) => {
  const o = Dt(t);
  return K`
    & img {
      max-height: ${n ? "none" : `calc(${o} - ${e}px)`};
    }
  `;
}, be = (e, t) => e === "Left" ? t ? "left-outer" : "left-inner" : "mid", ye = (e, t) => e === "Left" ? "mid" : t ? "right-outer" : "right-inner", Rt = "MediaContainer", Ht = new M(Rt), Ot = ({
  children: e,
  hasHeadline: t,
  imagePosition: n,
  mediaSize: o = "3:4"
}) => {
  const a = Ht.getComponentClassName(), r = o !== "3:4", s = {
    options: { columnStart: "left-outer", columnEnd: "right-outer" },
    mdOptions: {
      columnStart: be(n, r),
      columnEnd: ye(n, r),
      rowStart: t ? 2 : 1,
      rowEnd: t ? 3 : 2
    },
    lgOptions: {
      columnStart: be(n, r),
      columnEnd: ye(n, r)
    },
    className: a
  };
  return /* @__PURE__ */ i(H, { ...s, children: e });
}, je = "MediaItem", Te = new M(je), kt = ({
  mediaFrame: e,
  mediaSize: t,
  hasHeadline: n,
  variants: o,
  animate: a,
  offsetHeight: r = 0
}) => {
  const s = E(
    Te.getComponentClassName(),
    Te.getPropsValueClassName("mediaSize", t)
  ), c = Ce(r, n);
  return /* @__PURE__ */ A(
    _.div,
    {
      variants: o,
      animate: a,
      className: s,
      css: c
    },
    /* @__PURE__ */ A(
      fe,
      {
        ...e,
        "aria-hidden": !0,
        maxSrcSetWidth: 2e3,
        analyticsCompName: je
      }
    )
  );
}, _t = Re(
  ({
    contentLength: e,
    offsetHeight: t,
    theme: n,
    topSpacer: o,
    bottomSpacer: a,
    children: r,
    componentId: s,
    componentName: c,
    variantName: l,
    ...d
  }, u) => {
    const p = new M(c), g = E(
      p.getComponentClassName(),
      p.getElementClassName(l)
    ), f = E(p.getElementClassName("contents"));
    return /* @__PURE__ */ A(
      "div",
      {
        ref: u,
        id: s,
        className: g,
        css: K`
          min-height: calc(100vh - ${t}px);
        `,
        style: Me({ "--item-count": e })
      },
      /* @__PURE__ */ A(
        oe,
        {
          theme: n.toLowerCase(),
          options: {
            topSpacing: o,
            bottomSpacing: a
          },
          mdOptions: {
            rowsGap: "value",
            rowsGapValue: "6vw"
          },
          className: f,
          css: K`
            height: calc(100vh - ${t}px);
            top: ${t}px;
          `,
          ...d
        },
        r
      )
    );
  }
), Bt = "TextGroupContainer", Vt = new M(Bt), Wt = ({
  style: e,
  hasHeadline: t,
  imagePosition: n,
  children: o
}) => {
  const a = E(Vt.getComponentClassName());
  return /* @__PURE__ */ i(H, { ...{
    options: {
      columnStart: "left-inner",
      columnEnd: "right-inner"
    },
    mdOptions: {
      columnStart: n === "Left" ? "inner-3" : "left-inner",
      columnEnd: n === "Left" ? "right-inner" : "inner-3",
      rowStart: t ? 2 : 1,
      rowEnd: t ? 3 : 2
    },
    lgOptions: {
      columnStart: n === "Left" ? "inner-8" : "left-inner",
      columnEnd: n === "Left" ? "right-inner" : "inner-6"
    },
    className: a
  }, children: /* @__PURE__ */ i(_.div, { style: e, children: o }) });
}, ge = "TextGroupItem", re = new M(ge), zt = ({
  textGroup: e,
  target: t,
  variants: n,
  animate: o,
  eventCb: a
}) => {
  const {
    headline: r,
    headlineTag: s,
    headlineSize: c,
    subheading: l,
    paragraph: d,
    paragraphSize: u,
    disclosureType: p
  } = e, g = E(re.getComponentClassName()), { onFocus: f, onAnimationComplete: h } = a, m = () => {
    te(f) && f(), setTimeout(
      () => t && ke.scrollTo(t, {
        duration: 300,
        smooth: !0
      })
    );
  }, C = () => {
    te(h) && h();
  };
  return /* @__PURE__ */ k("div", { className: g, children: [
    /* @__PURE__ */ i(
      _.div,
      {
        className: re.getElementClassName("header"),
        variants: n == null ? void 0 : n.alwaysDisplay,
        animate: o,
        onFocus: m,
        onClick: m,
        tabIndex: 0,
        onAnimationComplete: C,
        children: /* @__PURE__ */ i(
          O,
          {
            headline: r,
            headlineTag: s,
            headlineSize: c,
            analyticsCompName: ge
          }
        )
      }
    ),
    /* @__PURE__ */ i(
      _.div,
      {
        className: re.getElementClassName("info"),
        variants: n == null ? void 0 : n.hideOnScroll,
        animate: o,
        transition: {
          duration: ee.constants.Functional.multiplier.appear * 2,
          ease: ee.constants.Functional.ease
        },
        children: /* @__PURE__ */ i(
          O,
          {
            subheading: l,
            paragraph: d,
            paragraphSize: u,
            analyticsCompName: ge,
            disclosureType: p
          }
        )
      }
    )
  ] });
};
const qt = "DefaultAnimated", Ut = ({
  componentId: e,
  componentName: t,
  collection: n = [],
  headline: o,
  theme: a = "white",
  imagePosition: r = "Left",
  topSpacer: s = "6vw",
  bottomSpacer: c = "6vw",
  mediaSize: l = "3:4",
  itemSpotlightOption: d = "default",
  offsetHeight: u = 0,
  graphicColorBottom: p,
  graphicColorTop: g,
  graphicVersionBottom: f,
  graphicVersionTop: h
}) => {
  const m = q(null), C = n.length, {
    elScrollProgressInner: w,
    elScrollProgressOuter: N,
    isElementNearViewport: I
  } = Le(m, {
    viewportHeightOffset: u
  }), { segmentDefs: x, activeSegmentIdx: y, setTargetIndex: $, resetTargetIndex: R } = We({
    sectionRef: m,
    numSegments: C,
    scrollProgress: w,
    recalculateSegmentDefs: I
  }), { textSectionElHeight: B, textSectionEl: T } = $t(e), v = X(() => {
    var j;
    const P = B.current;
    if (P === 0)
      return ["100%", "-100%"];
    const b = ((j = T == null ? void 0 : T.children[0]) == null ? void 0 : j.clientHeight) || 0;
    if (P > b)
      return ["50%", "-50%"];
    const D = n.length, Y = P * 0.7, U = b - b / D - u / 2;
    return [`${Y}px`, `-${U}px`];
  }, [T == null ? void 0 : T.children, B.current]), S = pe(
    N,
    [0, 1],
    v
  ), { mediaCollection: G = [], textGroupCollection: L = [] } = X(
    () => Ue(n),
    [n]
  ), V = (P) => P === "exclusive" ? At : ze;
  return /* @__PURE__ */ i(Fe, { children: /* @__PURE__ */ k(
    _t,
    {
      contentLength: C,
      offsetHeight: u,
      theme: a,
      topSpacer: s,
      bottomSpacer: c,
      componentId: e,
      graphicColorBottom: p,
      graphicColorTop: g,
      graphicVersionBottom: f,
      graphicVersionTop: h,
      componentName: t,
      variantName: qt,
      ref: m,
      children: [
        o && qe(o),
        /* @__PURE__ */ i(
          Ot,
          {
            hasHeadline: !!o,
            imagePosition: r,
            mediaSize: l,
            children: G.map((P, b) => /* @__PURE__ */ i(
              kt,
              {
                hasHeadline: !!o,
                mediaSize: l,
                offsetHeight: u,
                mediaFrame: P,
                variants: Lt,
                animate: b === y ? "animate" : "initial",
                isActive: b === y
              },
              `media-${b + 1}`
            ))
          }
        ),
        /* @__PURE__ */ i(
          Wt,
          {
            style: { y: S },
            hasHeadline: !!o,
            imagePosition: r,
            children: L.map((P, b) => {
              const D = b === y;
              return /* @__PURE__ */ i(
                zt,
                {
                  textGroup: P,
                  target: x ? x[b].target : void 0,
                  variants: {
                    alwaysDisplay: V(d),
                    hideOnScroll: Mt
                  },
                  animate: D ? "animate" : "initial",
                  eventCb: {
                    onFocus: () => $(b),
                    onAnimationComplete: D ? R : void 0
                  }
                },
                `product-text-group-${b + 1}`
              );
            })
          }
        )
      ]
    }
  ) });
}, jt = (e, t) => (n) => ({
  options: {
    columnStart: "left-inner",
    columnEnd: "right-inner",
    verticalAlign: "center"
  },
  mdOptions: {
    columnStart: e === "Left" ? "inner-3" : "left-inner",
    columnEnd: e === "Left" ? "right-inner" : "inner-3",
    rowStart: t ? n + 2 : n + 1,
    rowEnd: t ? n + 3 : n + 2
  },
  lgOptions: {
    columnStart: e === "Left" ? "inner-8" : "left-inner",
    columnEnd: e === "Left" ? "right-inner" : "inner-6"
  }
}), Ee = (e, t) => e === "Left" ? t ? "left-outer" : "left-inner" : "mid", xe = (e, t) => e === "Left" ? "mid" : t ? "right-outer" : "right-inner", Xt = (e, t, n) => (o) => {
  const a = e !== "3:4";
  return {
    options: { columnStart: "left-outer", columnEnd: "right-outer" },
    mdOptions: {
      columnStart: Ee(
        t,
        a
      ),
      columnEnd: xe(t, a),
      rowStart: n ? o + 2 : o + 1,
      rowEnd: n ? o + 3 : o + 2
    },
    lgOptions: {
      columnStart: Ee(
        t,
        a
      ),
      columnEnd: xe(t, a)
    }
  };
};
const Yt = "DefaultStatic", ie = ({
  collection: e = [],
  headline: t,
  theme: n = "white",
  imagePosition: o = "Left",
  topSpacer: a = "6vw",
  bottomSpacer: r = "6vw",
  mediaSize: s = "3:4",
  isMobileViewport: c,
  offsetHeight: l = 0,
  componentName: d,
  componentId: u,
  graphicColorBottom: p,
  graphicColorTop: g,
  graphicVersionBottom: f,
  graphicVersionTop: h
}) => {
  const m = new M(d), C = E(
    m.getComponentClassName(),
    m.getElementClassName(Yt)
  ), w = !!t, N = Ce(
    l,
    w,
    c
  ), I = Xt(
    s,
    o,
    w
  ), x = jt(
    o,
    w
  );
  return /* @__PURE__ */ A(
    oe,
    {
      theme: n,
      options: {
        topSpacing: a,
        bottomSpacing: r,
        rowsGap: "value",
        rowsGapValue: "2rem"
      },
      graphicColorBottom: p,
      graphicColorTop: g,
      graphicVersionBottom: f,
      graphicVersionTop: h,
      className: C,
      id: u
    },
    t && qe(t),
    e.map((y, $) => /* @__PURE__ */ A(He, { key: `product-${$ + 1}` }, /* @__PURE__ */ A(
      H,
      {
        ...I($),
        className: m.getElementClassName("media-container")
      },
      /* @__PURE__ */ A(
        fe,
        {
          ...y.mediaFrame,
          mediaRatio: s,
          maxSrcSetWidth: 2e3,
          css: N
        }
      )
    ), /* @__PURE__ */ A(
      H,
      {
        ...x($),
        className: m.getElementClassName("text-container")
      },
      /* @__PURE__ */ A(O, { ...y.textGroup })
    )))
  );
}, Xe = {
  mediaLayout: "default",
  mediaGrid: "default",
  mediaBleed: "none"
}, Qt = [
  "0vw",
  "2vw",
  "4vw",
  "6vw",
  "8vw",
  "12vw",
  "16vw",
  "20vw",
  "24vw",
  "28vw",
  "30vw",
  "32vw"
], Kt = [
  "0vw",
  "2vw",
  "4vw",
  "6vw",
  "8vw",
  "12vw",
  "16vw"
], Jt = (e) => Qt.includes(e), Ge = (e) => Kt.includes(e), Ye = (e, t) => {
  if (!Ge(e) || !Ge(t))
    throw new Error(
      `Given spacer values cannot be added: ${e}, ${t}`
    );
  const o = `${parseInt(e, 10) + parseInt(t, 10)}vw`;
  if (!Jt(o))
    throw new Error(
      `The sum of two spacers is not supported in the design system: ${e}, ${t}`
    );
  return o;
}, Zt = Re(
  ({
    contentLength: e,
    offsetHeight: t,
    theme: n,
    topSpacer: o,
    bottomSpacer: a,
    children: r,
    componentId: s,
    componentName: c,
    variantName: l,
    sectionTransitionConfig: d,
    isProductSectionInView: u,
    isMobileViewport: p,
    componentOrderIdx: g = 0,
    mediaBleed: f
  }, h) => {
    const {
      sectionId: m,
      disableTransitions: C,
      ref: w
    } = ot(c, g), { scrollProgress: N } = at(m), {
      isDisabled: I,
      backgroundTransition: x,
      isFirstInBackgroundTransition: y
    } = d, { foundationColor: $ } = he(st), R = n, B = x || n, { sectionStyles: T } = rt(
      N,
      [0, 0.5],
      [R, B],
      m,
      y
    ), S = C || I || !!!x, G = pe(N, [0, 1], [1, 0]), L = q(null), { stickyStyles: V } = it(
      L,
      N
    ), P = S ? { opacity: 1 } : { opacity: G, ...V }, b = pe(N, [0, 1], [0, -100]), D = S ? {} : { y: b, ...T }, W = new M(c), Y = E(
      W.getComponentClassName(),
      W.getElementClassName(l),
      {
        "entry-animation": u
      },
      $,
      ct.getThemeClassName(n),
      { "section-wrapper-transparent": !S }
    ), U = E(
      W.getElementClassName("contents"),
      "section-wrapper-transparent"
    ), j = {
      ...P,
      ...Me({ "--item-count": e })
    }, ae = lt(h, L), J = f === "bottom" && !p;
    return /* @__PURE__ */ A(
      _.div,
      {
        ref: ae,
        id: s,
        className: Y,
        css: K`
          @media (min-width: ${we.lg}) {
            min-height: calc(100vh - ${t}px);
          }
        `,
        style: j
      },
      /* @__PURE__ */ A(
        oe,
        {
          ref: w,
          theme: n,
          options: {
            topSpacing: J ? Ye(o, a) : o,
            bottomSpacing: J ? "0vw" : a
          },
          mdOptions: {
            rowsGap: "value",
            rowsGapValue: "6vw"
          },
          className: U,
          css: K`
            @media (min-width: ${we.lg}) {
              height: calc(100vh - ${t}px);
              top: ${t}px;
            }
          `,
          motion: S ? "none" : "custom",
          motionProps: {
            style: D
          }
        },
        r
      )
    );
  }
), ce = (e, t) => e === "Left" ? t ? "left-edge" : "left-outer" : "mid", le = (e, t) => e === "Left" ? "mid" : t ? "right-edge" : "right-outer", en = "MediaContainer", tn = new M(en), nn = ({
  children: e,
  mediaGrid: t = "default",
  mediaBleed: n = "none",
  imagePosition: o
}) => {
  const a = tn.getComponentClassName(), r = n === "bottom", s = r || t === "large", c = {
    options: { columnStart: "left-outer", columnEnd: "right-outer" },
    mdOptions: {
      columnStart: ce(o),
      columnEnd: le(o),
      rowStart: 1,
      rowEnd: 2
    },
    lgOptions: {
      columnStart: ce(o, r),
      columnEnd: le(o, r)
    },
    xlOptions: {
      columnStart: ce(o, s),
      columnEnd: le(o, s)
    },
    className: a
  };
  return /* @__PURE__ */ i(H, { ...c, children: e });
}, on = ({
  backgroundMedia: e,
  backgroundMediaSize: t,
  mediaLoading: n
}) => {
  const o = {
    ...e,
    mediaRatio: t
  }, { type: a } = o;
  return a === "Image" && (o.image = {
    ...o.image,
    loading: n
  }), o;
}, an = "FeaturedProductCardMedia", Q = new M(an), sn = ({
  backgroundMedia: e,
  backgroundMediaSize: t = "3:4",
  foregroundImages: n = [],
  mediaCardWrapperProps: o = {},
  mediaLoading: a = "lazy"
}) => {
  const { className: r, ...s } = o, c = E(
    Q.getComponentClassName(),
    r
  ), l = on({
    backgroundMedia: e,
    backgroundMediaSize: t,
    mediaLoading: a
  }), d = (n == null ? void 0 : n.length) > 0, u = Q.getElementClassName("bg");
  return /* @__PURE__ */ k(_.div, { ...s, className: c, children: [
    /* @__PURE__ */ i(
      fe,
      {
        ...l,
        "aria-hidden": !0,
        maxSrcSetWidth: 2e3,
        isAnimated: !1,
        className: u
      }
    ),
    d && /* @__PURE__ */ i("div", { className: Q.getElementClassName("fg"), children: /* @__PURE__ */ i("div", { className: Q.getElementClassName("fg-card"), children: /* @__PURE__ */ i(
      "div",
      {
        className: Q.getElementClassName("fg-card-contents"),
        children: n == null ? void 0 : n.map((p, g) => /* @__PURE__ */ i(
          mt,
          {
            ...p,
            imageAltText: "",
            dimensions: {
              minHeight: "initial",
              minWidth: "initial"
            },
            isAnimated: !1,
            loading: a
          },
          `inner-card-${g + 1}`
        ))
      }
    ) }) })
  ] });
};
const rn = "FeaturedProductCard", me = new M(rn), ne = ({
  textGroup: e,
  hideHeadline: t = !1,
  cardWrapperProps: n = {},
  ...o
}) => {
  const a = !!e, r = a && t, { className: s, ...c } = n, { headline: l, ...d } = r ? e : {}, u = r ? d : e, p = E(
    me.getComponentClassName(),
    s,
    "white-plate",
    { [me.getElementClassName("with-text")]: a }
  );
  return /* @__PURE__ */ k("div", { ...c, className: p, children: [
    /* @__PURE__ */ i(sn, { ...o }),
    t ? /* @__PURE__ */ i(dt, { children: /* @__PURE__ */ i(
      O,
      {
        headline: l,
        headlineTag: "h3",
        headlineSize: "Headline 7",
        analyticsCompName: "Tabs",
        isAnimated: !1
      }
    ) }) : null,
    a ? /* @__PURE__ */ i(
      O,
      {
        ...u,
        isAnimated: !1,
        alignment: "Center",
        className: me.getElementClassName("text")
      }
    ) : null
  ] });
}, cn = "MediaItem", de = new M(cn), ln = ({
  mediaFrame: e,
  mediaSize: t,
  animate: n,
  offsetHeight: o = 0,
  currentState: a,
  id: r,
  fetchFeaturedImages: s,
  foregroundImages: c = [],
  mediaLayout: l = "default",
  mediaBleed: d = "none",
  mediaGrid: u = "default"
}) => {
  const p = E(
    de.getComponentClassName(),
    de.getPropsValueClassName("mediaSize", t),
    de.getPropsValueClassName("layout", l),
    a
  ), f = d === "bottom" || u === "large" ? "" : Ce(o, !1);
  return /* @__PURE__ */ A(
    _.div,
    {
      animate: n,
      transition: {
        duration: 0.7,
        ease: ee.constants.Functional.ease
      },
      id: r,
      className: p,
      css: f
    },
    /* @__PURE__ */ A(
      ne,
      {
        backgroundMedia: e,
        backgroundMediaSize: t,
        foregroundImages: c,
        mediaLoading: s ? "eager" : "lazy"
      }
    )
  );
}, mn = ({
  imagePosition: e,
  bottomSpacer: t,
  children: n
}) => {
  const o = "TextGroupContainer", a = new M(o), r = E(a.getComponentClassName());
  return /* @__PURE__ */ i(H, { ...{
    options: {
      columnStart: "left-inner",
      columnEnd: "right-inner"
    },
    mdOptions: {
      columnStart: "left-inner",
      columnEnd: "right-inner",
      rowStart: 1,
      rowEnd: 2,
      bottomSpacing: t
    },
    lgOptions: {
      columnStart: e === "Left" ? "inner-8" : "left-inner",
      columnEnd: e === "Left" ? "right-inner" : "inner-6"
    },
    className: r
  }, children: n });
}, Z = "TextGroupItem", ue = new M(Z), dn = ({
  textGroup: e,
  target: t,
  animate: n,
  variants: o,
  componentId: a,
  domReady: r,
  isActive: s,
  eventCb: c,
  id: l
}) => {
  const {
    headline: d,
    headlineTag: u,
    headlineSize: p,
    subheading: g,
    paragraph: f,
    paragraphSize: h,
    disclosureType: m,
    actionGroup: C
  } = e, w = E(ue.getComponentClassName()), { onFocus: N, onAnimationComplete: I } = c, x = () => {
    te(I) && I();
  }, y = () => {
    te(N) && N(), setTimeout(
      () => t && ke.scrollTo(t, {
        duration: 300,
        smooth: !0
      })
    );
  }, R = (() => typeof window > "u" ? null : document.querySelector(
    a ? `#${a} .text-group-tabs-portal` : ".text-group-tabs-portal"
  ))();
  if (r) {
    const B = document.querySelectorAll(
      `#${a} #featured-tab-content-${l} a`
    );
    s ? B.forEach((T) => {
      T.removeAttribute("tabindex");
    }) : B.forEach((T) => {
      T.setAttribute("tabindex", "-1");
    });
  }
  return /* @__PURE__ */ k("div", { className: w, children: [
    r && R ? _e(
      /* @__PURE__ */ i("div", { children: /* @__PURE__ */ i(
        "button",
        {
          type: "button",
          className: ue.getElementClassName("header"),
          onClick: y,
          tabIndex: 0,
          id: `tab-${l}`,
          role: "tab",
          "aria-selected": s,
          "aria-controls": `featured-tab-content-${l} featured-media-${l}`,
          children: /* @__PURE__ */ i(
            _.div,
            {
              variants: o.alwaysDisplay,
              animate: n,
              onAnimationComplete: x,
              children: /* @__PURE__ */ i(
                O,
                {
                  headline: d,
                  headlineTag: u,
                  headlineSize: p,
                  analyticsCompName: Z
                }
              )
            }
          )
        }
      ) }),
      R
    ) : /* @__PURE__ */ i("div", { style: { display: "none" }, children: /* @__PURE__ */ i(
      O,
      {
        headline: d,
        headlineTag: u,
        headlineSize: p,
        analyticsCompName: Z
      }
    ) }),
    /* @__PURE__ */ i(
      _.div,
      {
        className: E(
          ue.getElementClassName("info"),
          s ? "content-active" : ""
        ),
        variants: o.hideOnScroll,
        animate: n,
        "aria-hidden": !s,
        id: `featured-tab-content-${l}`,
        role: "tabpanel",
        "aria-labelledby": `tab-${l}`,
        transition: {
          duration: 1,
          ease: ee.constants.Functional.ease
        },
        children: /* @__PURE__ */ i(
          O,
          {
            subheading: g,
            paragraph: f,
            paragraphSize: h,
            analyticsCompName: Z,
            disclosureType: m,
            actionGroup: C
          }
        )
      }
    )
  ] });
};
const un = ({
  collection: e = [],
  imagePosition: t = "Left",
  mediaSize: n = "3:4",
  componentId: o,
  sectionRef: a,
  offsetHeight: r,
  topSpacer: s = "0vw",
  bottomSpacer: c = "0vw",
  featuredVariantConfig: l
}) => {
  const [d, u] = F(!1), {
    elScrollProgressInner: p,
    isElementNearViewport: g
  } = Le(a, {
    viewportHeightOffset: r
  }), f = e.length, { segmentDefs: h, activeSegmentIdx: m, setTargetIndex: C, resetTargetIndex: w } = We({
    sectionRef: a,
    numSegments: f,
    scrollProgress: p,
    recalculateSegmentDefs: g
  }), {
    mediaCollection: N = [],
    textGroupCollection: I = [],
    foreGroundMediaCollection: x = []
  } = Ue(e);
  z(() => {
    u(!0);
  }, []);
  const { mediaGrid: y, mediaBleed: $, mediaLayout: R } = l || Xe, T = $ === "bottom" ? Ye(s, c) : "0vw";
  return /* @__PURE__ */ k(Ae, { children: [
    /* @__PURE__ */ i(
      nn,
      {
        imagePosition: t,
        mediaGrid: y,
        mediaBleed: $,
        children: N.map((v, S) => {
          const G = S === m;
          let L;
          return S > m ? L = "media-next" : S === m ? L = "media-active" : L = "media-prev", /* @__PURE__ */ i(
            ln,
            {
              id: `featured-media-${S + 1}`,
              mediaSize: n,
              offsetHeight: r,
              mediaFrame: v,
              animate: S === m ? "animate" : "initial",
              isActive: G,
              currentState: L,
              foregroundImages: x[S],
              fetchFeaturedImages: g,
              mediaLayout: R,
              mediaBleed: $,
              mediaGrid: y
            },
            `featured-media-${S + 1}`
          );
        })
      }
    ),
    /* @__PURE__ */ i(
      mn,
      {
        imagePosition: t,
        bottomSpacer: T,
        children: /* @__PURE__ */ k("div", { className: "text-group-content-innerwrapper", children: [
          /* @__PURE__ */ i(
            "div",
            {
              className: "text-group-tabs-portal",
              role: d ? "tablist" : ""
            }
          ),
          /* @__PURE__ */ i("div", { className: "text-group-tab-content-wrapper", children: I.map((v, S) => {
            const G = S === m;
            return /* @__PURE__ */ i(
              dn,
              {
                id: `${S + 1}`,
                isActive: G,
                componentId: o,
                textGroup: v,
                target: h ? h[S].target : void 0,
                variants: {
                  alwaysDisplay: ze,
                  hideOnScroll: Ft
                },
                animate: S === m ? "animate" : "initial",
                domReady: d,
                eventCb: {
                  onFocus: () => C(S),
                  onAnimationComplete: G ? w : void 0
                }
              },
              `product-text-group-${S + 1}`
            );
          }) })
        ] })
      }
    )
  ] });
};
const pn = ({ itemProps: e, carouselState: t = {} }) => {
  const { mediaFrame: n, textGroup: o, ...a } = e, { isVisibleSlide: r } = t;
  let s = o;
  return o.actionGroup && (s = {
    ...o,
    actionGroup: { ...o.actionGroup, isFocusable: r }
  }), /* @__PURE__ */ i(
    ne,
    {
      ...a,
      textGroup: s,
      backgroundMedia: n,
      hideHeadline: !0
    }
  );
}, gn = ({
  collection: e = [],
  componentId: t,
  featuredVariantConfig: n = {},
  carouselDetails: o = {
    ariaLabel: "",
    prevButtonLabel: "",
    nextButtonLabel: "",
    pageNavButtonLabel: "",
    slideLabel: "",
    pageLabel: ""
  }
}) => {
  const [a, r] = F(!1), [s, c] = F([]), [l, d] = F([]), [u, p] = F(0), [g, f] = F(!1), [h, m] = F(0), [C, w] = F(
    "start"
  ), N = q(null), { mediaLayout: I = "default" } = n, x = E({
    "media-item-layout-minimal": I === "minimal"
  }), y = E({
    "scrollable-tabs": g,
    "right-shim": g && C === "start",
    "left-shim": C === "end",
    "both-shims": C === "mid"
  }), $ = () => function(S) {
    const { headline: G } = S.textGroup;
    return /* @__PURE__ */ i(
      O,
      {
        headline: G,
        headlineTag: "h3",
        headlineSize: "Headline 7",
        analyticsCompName: "Tabs",
        isAnimated: !1
      }
    );
  }, R = (v) => {
    setTimeout(() => {
      u !== v && p(v);
    }, 0);
  };
  z(() => {
    r(!0);
    const v = [], S = [], G = 24, L = 48, V = () => {
      var U;
      const P = t ? `#${t} .page-nav-container` : ".product-scroll-section .page-nav-container", b = ((U = document.querySelector(P)) == null ? void 0 : U.getBoundingClientRect().left) || 0, D = t ? `#${t} .page-nav-container .carousel-indicator` : ".product-scroll-section .page-nav-container .carousel-indicator";
      let W = 0;
      document.querySelectorAll(D).forEach((j, ae, J) => {
        const { width: se, left: Qe } = j.getBoundingClientRect(), Ke = Qe - b;
        v.push(se), S.push(Ke), ae < J.length - 1 ? W += se + G : W += se;
      }), m(W), c([...new Set(v)]), d([...new Set(S)]);
      const Y = window.innerWidth - L;
      f(W > Y);
    };
    return setTimeout(() => {
      V();
    }, 100), window.addEventListener("resize", V), () => {
      window.removeEventListener("resize", V);
    };
  }, [t, h]), z(() => {
    if (g) {
      const v = N.current, S = v == null ? void 0 : v.parentElement, G = () => {
        if (S) {
          const { scrollWidth: L, offsetWidth: V, scrollLeft: P } = S, b = Math.abs(P), D = L - V;
          b > 0 ? w("mid") : w("start"), D > 0 && b >= D - 1 && w("end");
        }
      };
      v && S ? (S.addEventListener("scroll", G), v.style.width = `${h}px`) : S == null || S.removeEventListener("scroll", G);
    }
  }, [h, g]);
  const T = (() => typeof window > "u" ? null : document.querySelector(
    t ? `#${t}.product-scroll-section .carousel .page-nav-container` : ".product-scroll-section .carousel .page-nav-container"
  ))();
  return /* @__PURE__ */ k(H, { options: { columnStart: "left-inner", columnEnd: "right-inner" }, children: [
    a && T && _e(
      /* @__PURE__ */ k(Ae, { children: [
        /* @__PURE__ */ i("div", { className: "tab-bar", ref: N }),
        /* @__PURE__ */ i(
          _.div,
          {
            animate: {
              x: l[u - 1],
              width: s[u - 1]
            },
            initial: {
              x: l[0],
              width: s[0]
            },
            className: "tab-active-indicator",
            transition: { ease: "easeOut", duration: 0.3 }
          }
        )
      ] }),
      T
    ),
    /* @__PURE__ */ i(
      ut,
      {
        classes: { navContainer: y, slide: x },
        items: e,
        paginationPlacement: "top",
        backgroundColor: null,
        carouselDetails: o,
        renderItem: pn,
        renderPaginationContent: $(),
        onCarouselPageChange: R,
        breakpoints: {
          md: {
            slideWidth: 460
          }
        }
      }
    )
  ] });
}, Pe = ({
  collection: e = [],
  imagePosition: t = "Left",
  mediaSize: n = "3:4",
  theme: o = "white",
  topSpacer: a = "6vw",
  bottomSpacer: r = "6vw",
  isMobileViewport: s,
  offsetHeight: c = 0,
  componentId: l,
  componentName: d,
  sectionTransitionConfig: u = gt,
  componentContext: p = {},
  featuredVariantConfig: g = Xe,
  ...f
}) => {
  const { componentOrderIdx: h = 0 } = p, m = q(null), C = s ? "FeaturedAnimatedMobile" : "FeaturedAnimatedDesktop", w = pt(m, {
    once: !0,
    amount: 0.2
  });
  return /* @__PURE__ */ i(Fe, { children: /* @__PURE__ */ i(
    Zt,
    {
      ref: m,
      contentLength: e.length,
      offsetHeight: c,
      theme: o,
      topSpacer: a,
      bottomSpacer: r,
      componentId: l,
      componentName: d,
      variantName: C,
      sectionTransitionConfig: u,
      componentOrderIdx: h,
      isProductSectionInView: w,
      isMobileViewport: s,
      mediaBleed: g == null ? void 0 : g.mediaBleed,
      children: s ? /* @__PURE__ */ i(
        gn,
        {
          collection: e,
          theme: o,
          componentId: l,
          carouselDetails: f.carouselDetails,
          isMobileViewport: s,
          featuredVariantConfig: g
        }
      ) : /* @__PURE__ */ i(
        un,
        {
          collection: e,
          imagePosition: t,
          mediaSize: n,
          isMobileViewport: s,
          componentId: l,
          sectionRef: m,
          offsetHeight: c,
          featuredVariantConfig: g,
          topSpacer: a,
          bottomSpacer: r
        }
      )
    }
  ) });
}, Sn = (e, t, n) => ({
  topSpacing: e ? "4.5rem" : t,
  bottomSpacing: e ? "4.5rem" : n,
  rowsGap: "value",
  rowsGapValue: "2rem"
}), fn = (e) => (t) => ({
  options: {
    columnStart: "left-inner",
    columnEnd: "right-inner"
  },
  lgOptions: {
    columnStart: e === "Left" ? "inner-8" : "left-inner",
    columnEnd: e === "Left" ? "right-inner" : "inner-6",
    rowStart: t + 1,
    rowEnd: t + 2
  }
}), hn = (e) => e === "Left" ? "left-outer" : "mid", Cn = (e) => e === "Left" ? "mid" : "right-outer", wn = (e) => (t) => ({
  options: { columnStart: "left-inner", columnEnd: "right-inner" },
  lgOptions: {
    columnStart: hn(e),
    columnEnd: Cn(e),
    rowStart: t + 1,
    rowEnd: t + 2
  }
});
const Nn = "FeaturedStatic", Ie = ({
  collection: e = [],
  theme: t = "white",
  imagePosition: n = "Left",
  topSpacer: o = "6vw",
  bottomSpacer: a = "6vw",
  mediaSize: r = "3:4",
  isMobileViewport: s,
  componentName: c,
  componentId: l
}) => {
  const d = new M(c), u = Sn(s, o, a), p = wn(n), g = fn(n), f = d.getElementClassName(
    "mobile-only-wrapper"
  ), h = E(
    d.getComponentClassName(),
    d.getElementClassName(Nn)
  );
  return /* @__PURE__ */ i(
    oe,
    {
      theme: t,
      options: { ...u },
      className: h,
      id: l,
      children: e.map((m, C) => s ? /* @__PURE__ */ i(
        H,
        {
          options: { columnStart: "left-inner", columnEnd: "right-inner" },
          className: f,
          children: /* @__PURE__ */ i(
            ne,
            {
              backgroundMedia: m.mediaFrame,
              backgroundMediaSize: r,
              foregroundImages: m.foregroundImages,
              textGroup: m.textGroup
            }
          )
        },
        `product-${C + 1}`
      ) : /* @__PURE__ */ k(He, { children: [
        /* @__PURE__ */ i(
          H,
          {
            ...p(C),
            className: d.getElementClassName("media-container"),
            children: /* @__PURE__ */ i(
              ne,
              {
                backgroundMedia: m.mediaFrame,
                backgroundMediaSize: r,
                foregroundImages: m.foregroundImages
              }
            )
          }
        ),
        /* @__PURE__ */ i(
          H,
          {
            ...g(C),
            className: d.getElementClassName("text-container"),
            children: /* @__PURE__ */ i(
              O,
              {
                ...m.textGroup,
                isAnimated: !1,
                alignment: s ? "Center" : "Start"
              }
            )
          }
        )
      ] }, `product-${C + 1}`))
    }
  );
}, vn = {
  default: {
    desktop: { animated: Ut, static: ie },
    mobile: { animated: ie, static: ie }
  },
  featured: {
    desktop: {
      animated: Pe,
      static: Ie
    },
    mobile: { animated: Pe, static: Ie }
  }
}, $e = "ProductScrollSection", Ln = ({
  variant: e = "default",
  applyScroll: t = !0,
  componentId: n = $e,
  ...o
}) => {
  const a = St(), r = ft(), c = a || r || !t, [l, d] = ht([
    "Below MD",
    "Below LG"
  ]), u = e === "default" ? l : d, p = u ? "mobile" : "desktop", f = c || e === "default" && u ? "static" : "animated", h = Gt(), m = vn[e][p][f];
  return /* @__PURE__ */ i(
    m,
    {
      ...o,
      variant: e,
      isMobileViewport: u,
      offsetHeight: h,
      componentId: n,
      componentName: $e
    }
  );
};
export {
  Ln as P,
  Mn as a,
  xt as u
};
//# sourceMappingURL=ProductScrollSection-6842acd1.js.map
